import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { AppRoutes } from './router';
import { ModalProvider } from './contexts/ModalContext';
import Navbar from './components/feature/Navbar';
import Footer from './components/feature/Footer';
import ConsultModal from './components/feature/ConsultModal';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ModalProvider>
          <Navbar />
          <main>
            <AppRoutes />
          </main>
          <Footer />
          <ConsultModal />
        </ModalProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
